(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ip-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ipAtcBound) return;
    window.__ipAtcBound = true;

    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-ip-atc-form]');
      if (!form) return;

      e.preventDefault();

      var btn = form.querySelector('button[type="submit"]');
      var variantId = form.querySelector('input[name="id"]').value;
      var orig = btn.textContent;

      btn.textContent = 'Agregando...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error();
          return fetch('/cart.js');
        })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          btn.textContent = '¡Agregado!';

          var event = new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: variantId,
              data: {
                source: 'product-form-component',
                itemCount: 1,
                variantId: variantId,
              },
            },
          });
          document.dispatchEvent(event);

          setTimeout(function () {
            btn.textContent = orig;
            btn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          btn.textContent = 'Error';
          setTimeout(function () {
            btn.textContent = orig;
            btn.disabled = false;
          }, 2000);
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
